import api from "./axiosInstance";

export const getArtistMessages = async (artistId) => {
  const res = await api.get(`api/v1/artists/${artistId}/messages/`);
  return res.data;
};

export const sendArtistMessage = async (artistId, formData) => {
  const res = await api.post(
    `api/v1/artists/${artistId}/messages/`,
    formData
  );
  return res.data;
};
